import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step6.sectionTitle',
    defaultMessage: 'Section 3 - Cancellation, additional expenses & travel delay',
  },
  title: {
    id: 'fastCover.step6.title',
    defaultMessage: 'Title',
  },
  areYouClaimingForCancellationAmendmentOrDelay: {
    id: 'fastCover.step6.areYouClaimingForCancellationAmendmentOrDelay',
    defaultMessage: 'Are you claiming for a cancellation or amendment to your trip?',
  },
  yes: {
    id: 'fastCover.step6.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step6.no',
    defaultMessage: 'No',
  },
  areYouClaimingForTripCancellationExpenses: {
    id: 'fastCover.step6.areYouClaimingForTripCancellationExpenses',
    defaultMessage: 'Are you claiming for Trip Cancellation Expenses?',
  },
  areYouClaimingForTripDisruptionOrAdditionalExpenses: {
    id: 'fastCover.step6.areYouClaimingForTripDisruptionOrAdditionalExpenses',
    defaultMessage: 'Are you claiming for Trip disruption or Additional Expenses?',
  },
  areYouClaimingForTripResumptionExpenses: {
    id: 'fastCover.step6.areYouClaimingForTripResumptionExpenses',
    defaultMessage: 'Are you claiming for Trip Resumption Expenses?',
  },
  areYouClaimingForAlternativeTransportExpenses: {
    id: 'fastCover.step6.areYouClaimingForAlternativeTransportExpenses',
    defaultMessage: 'Are you claiming for Alternative Transport Expenses?',
  },
  areYouClaimingForATravelDelay: {
    id: 'fastCover.step6.areYouClaimingForATravelDelay',
    defaultMessage: 'Are you claiming for a Travel Delay?',
  },
  dateCancellationOrAmendmentMade: {
    id: 'fastCover.step6.dateCancellationOrAmendmentMade',
    defaultMessage: 'Date cancellation or amendment made',
  },
  reasonForCancellationOrAmendment: {
    id: 'fastCover.step6.reasonForCancellationOrAmendment',
    defaultMessage: 'Reason for cancellation/amendment',
  },
  medical: {
    id: 'fastCover.step6.reasonForCancellationOrAmendment.medical',
    defaultMessage: 'Medical reasons (illness or injury) - Please also complete Section 13 Medical Certificate and Section 12 Medical authority',
  },
  travel: {
    id: 'fastCover.step6.reasonForCancellationOrAmendment.travel',
    defaultMessage: 'Travel provider (Airline, hotel, cruise liner, tour company etc)',
  },
  weather: {
    id: 'fastCover.step6.reasonForCancellationOrAmendment.weather',
    defaultMessage: 'Weather event',
  },
  redundancy: {
    id: 'fastCover.step6.reasonForCancellationOrAmendment.redundancy',
    defaultMessage: 'Redundancy',
  },
  other: {
    id: 'fastCover.step6.reasonForCancellationOrAmendment.other',
    defaultMessage: 'Other (please describe)',
  },
  cancellationExpenses: {
    id: 'fastCover.step6.cancellationExpenses',
    defaultMessage: 'Cancellation Expenses',
  },
  addCancellationExpense: {
    id: 'fastCover.step6.addCancellationExpense',
    defaultMessage: 'Add cancellation expense',
  },
  cancellationExpenseTitle: {
    id: 'fastCover.step6.cancellationExpenseTitle',
    defaultMessage: 'Cancellation Expense {index}',
  },
  cancellationExpensesDateCancelled: {
    id: 'fastCover.step6.cancellationExpenses.dateCancelled',
    defaultMessage: 'Date Cancelled',
  },
  cancellationExpensesCancelledBookingDescription: {
    id: 'fastCover.step6.cancellationExpenses.cancelledBookingDescription',
    defaultMessage: 'Cancelled Booking Description',
  },
  cancellationExpensesSupplier: {
    id: 'fastCover.step6.cancellationExpenses.supplier',
    defaultMessage: 'Travel Provider',
  },
  cancellationExpensesPrePaidAmount: {
    id: 'fastCover.step6.cancellationExpenses.cancellationExpensesPrePaidAmount',
    defaultMessage: 'Pre-Paid Amount',
  },
  cancellationExpensesRefundCompensationReceived: {
    id: 'fastCover.step6.cancellationExpenses.refundCompensationReceived',
    defaultMessage: 'Refund/Compensation Received',
  },
  cancellationExpensesCurrency: {
    id: 'fastCover.step6.cancellationExpenses.cancellationExpensesCurrency',
    defaultMessage: 'Currency',
  },
  textBoxEg: {
    id: 'fastCover.step6.cancellationExpenses.textBoxEg',
    defaultMessage: 'e.g: {value}',
  },
  additionalExpenses: {
    id: 'fastCover.step6.additionalExpenses',
    defaultMessage: 'Additional Expenses',
  },
  additionalExpenseTitle: {
    id: 'fastCover.step6.additionalExpenseTitle',
    defaultMessage: 'Additional Expense {index}',
  },
  addAdditionalExpense: {
    id: 'fastCover.step6.additionalExpenses.addAdditionalExpense',
    defaultMessage: 'Add Additional expenses',
  },
  additionalExpensesDateOfExpense: {
    id: 'fastCover.step6.additionalExpenses.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  additionalExpensesDescription: {
    id: 'fastCover.step6.additionalExpenses.description',
    defaultMessage: 'Description',
  },
  additionalExpensesSupplier: {
    id: 'fastCover.step6.additionalExpenses.supplier',
    defaultMessage: 'Travel Provider',
  },
  additionalExpensesAmountPaid: {
    id: 'fastCover.step6.additionalExpenses.amountPaid',
    defaultMessage: 'Amount Paid',
  },
  additionalExpensesCurrency: {
    id: 'fastCover.step6.additionalExpenses.additionalExpensesCurrency',
    defaultMessage: 'Currency',
  },
  delayedTravelTitle: {
    id: 'fastCover.step6.delayedTravelTitle',
    defaultMessage: 'Delayed Travel',
  },
  whatWasTheReasonForYourDelay: {
    id: 'fastCover.step6.delayedTravel.whatWasTheReasonForYourDelay',
    defaultMessage: 'What was the reason for your delay?',
  },
  dateYouWereDueToDepart: {
    id: 'fastCover.step6.delayedTravel.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },
  timeYouWereDueToDepart: {
    id: 'fastCover.step6.delayedTravel.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },
  dateYouActuallyDeparted: {
    id: 'fastCover.step6.delayedTravel.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },
  timeYouActuallyDeparted: {
    id: 'fastCover.step6.delayedTravel.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },
  didYouReceiveAnyCompensationFromYourTravelProvider: {
    id: 'fastCover.step6.delayedTravel.didYouReceiveAnyCompensationFromYourTravelProvider',
    defaultMessage: 'Did you receive any compensation from your Travel Provider?',
  },
  didYouReceiveAnyCompensationFromYourTravelProviderTextNote: {
    id: 'fastCover.step6.delayedTravel.didYouReceiveAnyCompensationFromYourTravelProviderTextNote',
    defaultMessage: 'Airline, hotel, cruise liner, tour company etc.',
  },
  delayedTravelExpenses: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses',
    defaultMessage: 'Delayed Travel Expenses',
  },
  addDelayExpense: {
    id: 'fastCover.step6.delayedTravel.addDelayExpense',
    defaultMessage: 'Add Delay Expense',
  },
  delayedTravelExpenseTitle: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.delayedTravelExpenseTitle',
    defaultMessage: 'Delay Expense {index}',
  },
  delayedTravelExpenseDate: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.date',
    defaultMessage: 'Date of Expense',
  },
  delayedTravelExpenseDescription: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.description',
    defaultMessage: 'Description',
  },
  delayedTravelExpenseAmount: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.amount',
    defaultMessage: 'Amount',
  },
  delayedTravelExpenseCurrency: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.currency',
    defaultMessage: 'Currency',
  },
  delayedTravelExpenseAmountRefunded: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.amountRefunded',
    defaultMessage: 'Amount refunded from originally planned expense',
  },
  delayedTravelExpenseAmountClaimed: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  addDelayedTravelExpense: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.addDelayedTravelExpense',
    defaultMessage: 'Add Delayed travel expense',
  },
  ifNoAmountRefundedThenEnterZero: {
    id: 'fastCover.step6.delayedTravel.delayedTravelExpenses.ifNoAmountRefundedThenEnterZero',
    defaultMessage: '(If no amount refunded then enter zero)',
  },
  cancellationExpenseRequired: {
    id: 'fastCover.step6.cancellationExpenseRequired',
    defaultMessage: 'Cancellation Expense table fields are required fields.',
  },
  additionalExpenseRequired: {
    id: 'fastCover.step6.additionalExpenseRequired',
    defaultMessage: 'Additional Expense table fields are required fields.',
  },
  delayedTravelExpensesRequired: {
    id: 'fastCover.step6.delayedTravelExpensesRequired',
    defaultMessage: 'Delayed Travel Expenses table fields are required fields.',
  },
  dateRefundWasReceived: {
    id: 'fastCover.step6.dateRefundWasReceived',
    defaultMessage: 'Date Refund was Received',
  },
  amountOfCompensation: {
    id: 'fastCover.step6.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.step6.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.step6.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.step6.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.step6.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  isRequired: {
    id: 'fastCover.step6.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  areThereAnyAdditionalExpensesToBeClaimed: {
    id: 'fastCover.step6.areThereAnyAdditionalExpensesToBeClaimed',
    defaultMessage: 'Are there any additional expenses to be claimed?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step6/messages.js